export default "__VITE_ASSET__C7ej0KQK__"